// engagement strings (en). Filled by i18n extraction.
const engagement = {
	engagement: {
		// Engagement page
		title: 'Engagement',
		last7Days: 'Last 7 Days',
		last15Days: 'Last 15 Days',
		last30Days: 'Last 30 Days',
		last2Months: 'Last 2 months',
		last6Months: 'Last 6 months',
		lastYear: 'Last year',
		allCards: 'All cards',
		statContactEngagement: 'Contact Engagement',
		statEmailsOpened: 'Emails Opened',
		statCardsOpened: 'Cards Opened',
		statTotalReactions: 'Total Reactions',
		statTotalComments: 'Total Comments',
		statTotalDownloads: 'Total Downloads',
		cardEngagement: 'Card Engagement',
		noSentCards: 'No sent cards found. Send a card to see engagement data.',
		untitled: 'Untitled',
		cardAlt: 'Card',
		loading: 'Loading...',
		analytics: 'Analytics',
		reactions: 'Reactions',
		noReactions: 'No reactions',
		comments: 'Comments (%{count})',
		anonymous: 'Anonymous',
		noComments: 'No comments',
		// Contacts engagement list
		viewContacts: 'View contacts',
		cardStats: 'Card stats',
		mostEngagedContacts: 'Most Engaged Contacts',
		noContactsYet: 'You do not have any contacts yet.',
		tooltipCardsOpened: 'Total cards opened by this contact',
		tooltipCardsSent: 'Total cards sent to this contact',
		// Activities
		typeLabel: 'Type',
		optionClicks: 'Clicks',
		impression: 'Impression',
		filterLabel: 'Filter',
		optionLast10Days: 'Last 10 days',
		optionLast7Days: 'Last 7 days',
		newClick: '‘Image name’ got a new click',
		justNow: 'Just now',
		messengerRedirect: 'Someone from messenger redirected to www.cardclan.io',
		conversion: 'Conversion',
		sourceLabel: 'Source: %{source}',
		newImpression: '‘Image name’ got a new impression',
		oneHour: '1h',
		twitterRedirect: 'Someone from twitter redirected to www.cardclan.io',
	} as Record<string, string>,
};
export default engagement;
